import { Pipe, PipeTransform } from "@angular/core";
import { LocaleService } from "../services/locale/locale-service";
/**
 * 반올림 pipe
 */
@Pipe({
  name: 'questionTitle'
})
export class QuestionTitlePipe implements PipeTransform {

  constructor(private localeService: LocaleService) { }

  transform(title: string, name: string = 'new', isRemoved: boolean = false): string {
    if (title.includes('{firstname_to}')) {
      if (isRemoved) {
        const replacedName = this.localeService.isKo ? '상대방' : 'host'
        // {firstname_to} 뒤에 '님'이 안붙어있을 경우를 대비해 replace를 한번 더 진행
        return title.replace(/{firstname_to}님/gi, replacedName).replace(/{firstname_to}/gi, replacedName);
      }
      return title.replace(/{firstname_to}/gi, name);
    } else {
      return title;
    }
  }

}